import type { ChatWithRelations } from "@ch/generated";
import storage from "localforage";
import { persistReducer } from "redux-persist";
import ChatActionTypes from "./types";

export interface IAppChatState {
  error?: string;
  activeChatRoomId?: string;
  unreadMessages?: ChatWithRelations[];
  id?: string; // This is used for the unread message update
  onlineMembers?: string[];
  coachIdsWithActiveUserSubscription?: string[];
}

export const INITIAL_CHAT_STATE: IAppChatState = {
  error: "",
  activeChatRoomId: "",
  unreadMessages: [],
  onlineMembers: [],
  coachIdsWithActiveUserSubscription: [],
};

function chatReducer(
  // Redux insists
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: IAppChatState = INITIAL_CHAT_STATE,
  { type, payload }: { type: ChatActionTypes; payload: Partial<IAppChatState> },
) {
  switch (type) {
    case ChatActionTypes.UPDATE_APP_CHAT_STATE:
      return { ...state, ...payload };
    case ChatActionTypes.ADD_UNREAD_CHAT:
      return {
        ...state,
        unreadMessages: [
          ...(state.unreadMessages ?? []),
          payload.unreadMessages![0],
        ],
      };
    case ChatActionTypes.READ_CHAT:
      return {
        ...state,
        unreadMessages: state.unreadMessages?.filter(
          (item) => item.id !== payload.id,
        ),
      };

    case ChatActionTypes.ADD_COACH_IDS_WITH_ACTIVE_USER_SUBSCRIPTION:
      return {
        ...state,
        coachIdsWithActiveUserSubscription:
          payload.coachIdsWithActiveUserSubscription,
      };
    default:
      return state;
  }
}

const persistConfig = {
  key: "chat",
  storage,
  blacklist: ["error", "isLoading", "loading"],
};

export default persistReducer(persistConfig, chatReducer);
